export default "__VITE_ASSET__0cc232b6__"